import { z } from 'zod';
/** The two document control accounts: Debtors and Creditors. */
export const PostingControlRoleSchema = z.enum(['ACCOUNTS_RECEIVABLE', 'ACCOUNTS_PAYABLE']);
export const OpeningItemisationQuerySchema = z.strictObject({
    controlRole: PostingControlRoleSchema,
});
/**
 * What an opening-item dry run needs from the server. `conversionDate` is null
 * when the ledger has no opening date; `availableMinorUnits` is null until
 * opening balances are posted, because there is no budget to itemise before then.
 */
export const OpeningItemisationStatusSchema = z.object({
    conversionDate: z.iso.date().nullable(),
    availableMinorUnits: z.number().int().nullable(),
});
